import knowledgeBaseClient from '../services/http-client';
import { useModuleMutation } from '../../useModuleMutation';
import { knowledgeBaseKeys } from './queries';
import type { SearchRequest, SearchResponse, IndexResponse } from './interfaces';

// POST /search — semantic search against the knowledge base
export const useSearchMutation = () =>
  useModuleMutation({
    fn: (data: SearchRequest) => knowledgeBaseClient.post<SearchResponse>('/search', data),
  });

// POST /index — trigger a reindex of the current website
export const useIndexMutation = () =>
  useModuleMutation({
    fn: () => knowledgeBaseClient.post<IndexResponse>('/index', {}),
    // Invalidate statistics since a new entry is created
    invalidate: (clientId) => [knowledgeBaseKeys.statistics(clientId)],
  });
